<!-- eslint-disable max-len -->
<template>
  <div>
    <b-modal
      id="workorderEditModal"
      size="lg"
      @ok="saveWorkorder()"
      :ok-title='"Save"'
      :ok-disabled='!workorderEditModelValid'
    >
      <template v-slot:modal-title>Edit Work Order</template>
      <b-card-body class='project-workorder-edit-card-body'>
        <div class='details-label project-workorder-bills-items-details-label'>Contract</div>
        <div v-if='workorderEditModel'>{{ workorderEditModel.opportunityName }}</div>
        <div class='details-label project-workorder-bills-items-details-label'>Work Order Number</div>
        <div v-if='workorderEditModel'>{{ workorderEditModel.workorderNumber }}</div>
      </b-card-body>
      <VueFormGenerator
        :model="workorderEditModel"
        :schema="workorderEditSchema"
        :options="{
          validateAfterLoad: false,
          validateAfterChanged: true,
          validateAsync: true
        }"
        @validated="onWorkorderEditValidated"
        @model-updated='onWorkorderEditModelUpdated'
      />
      <template v-slot:modal-footer="{ cancel, ok }">
        <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>Cancel</b-button>
        <b-button size="sm" variant="success" @click="ok" class='btn-success'>Save</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable max-len, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';
import ProjectSchemaHelper from '@/mixins/projectSchemaHelper';

export default {
  name: 'ProjectWorkorderEdit',
  mixins: [
    ProjectSchemaHelper,
  ],
  computed: {
    ...mapState('Workorder', {
      workorderEditModel: (e) => e.workorderEditModel,
    }),
  },
  data() {
    return {
      workorderEditModelValid: false,
      workorderEditSchema: {},
    };
  },
  mounted() {
    this.workorderEditSchema = this.getProjectWorkorderEditSchema();
    this.$bvModal.show('workorderEditModal');
    this.validateWorkOrderEditFields();
  },
  methods: {
    onWorkorderEditValidated(isValid, errors) {
      this.workorderEditModelValid = isValid;
      this.validateWorkOrderEditFields(errors || []);
    },
    onWorkorderEditModelUpdated(fieldValue, fieldName) {
      if (fieldName === 'vendorType') {
        if (this.workorderEditModel.vendorType && this.workorderEditModel.vendorType === 'Individual Contact') {
          this.workorderEditModel.vendorOrganization = null;
          this.workorderEditModel.vendorOrganizationId = null;
        }
        if (this.workorderEditModel.vendorType && this.workorderEditModel.vendorType === 'Organization') {
          this.workorderEditModel.vendorContact = null;
          this.workorderEditModel.vendorContactId = null;
        }
      }
    },
    async saveWorkorder() {

      if (this.workorderEditModel.vendorContact) {
        this.workorderEditModel.vendorContactId = this.workorderEditModel.vendorContact.id;
        this.workorderEditModel.vendorOrganizationId = null;
      }

      if (this.workorderEditModel.vendorOrganization) {
        this.workorderEditModel.vendorContactId = null;
        this.workorderEditModel.vendorOrganizationId = this.workorderEditModel.vendorOrganization.id;
      }
      // const requestedDateYear = this.workorderEditModel.requestedDate.getFullYear();
      const requestedDateYear = new Date(this.workorderEditModel.requestedDate).getFullYear();
      const requestedDateMonth = new Date(this.workorderEditModel.requestedDate).getMonth() + 1;
      const requestedDateDay = new Date(this.workorderEditModel.requestedDate).getDate();
      const workorderInputModel = {
        workorderId: this.workorderEditModel.id,
        workorderName: this.workorderEditModel.workorderName,
        // requestedDate: new Date(this.workorderEditModel.requestedDate),
        requestedDateYear,
        requestedDateMonth,
        requestedDateDay,
        vendorContactId: this.workorderEditModel.vendorContactId,
        vendorOrganizationId: this.workorderEditModel.vendorOrganizationId,
        contractorSpecialInstructions: this.workorderEditModel.contractorSpecialInstructions,
      };

      await this.$store.dispatch('Workorder/setFormLoading', true);
      await this.$store.dispatch('Workorder/putWorkorder', workorderInputModel);
      await this.$store.dispatch('Workorder/setWorkorderEditModel', this.workorderEditModel);
      await this.$store.dispatch('Workorder/setFormLoading', false);

      // Refetching is the parent's job. ProjectWorkorders.load() refetches the work orders *and*
      // re-applies the client-side hydration a bare Project/getProjectWorkorders would discard
      // (workOrderBills, quantityBilledToDate). Announcing the save instead of guessing at it
      // from a mutation plus a browser-clock-vs-Insightly-clock date comparison.
      this.$emit('saved');
    },
    validateWorkOrderEditFields(errors) {
      this.workorderEditModelValid = true;

      if (!this.workorderEditModel.workorderName || (this.workorderEditModel.workorderName ?? '').length === 0) {
        console.warn('Invalid field: workorderName');
        this.workorderEditModelValid = false;
      }
      if (!this.workorderEditModel.requestedDate || (this.workorderEditModel.requestedDate === null)) {
        console.warn('Invalid field: requestedDate');
        this.workorderEditModelValid = false;
      }
      if (this.workorderEditModel.vendorType === 'Individual Contact') {
        if (!this.workorderEditModel.vendorContact || this.workorderEditModel.vendorContact === null) {
          console.warn('Invalid field: vendorContact');
          this.workorderEditModelValid = false;
        }
      } else if (!this.workorderEditModel.vendorOrganization || this.workorderEditModel.vendorOrganization === null) {
        console.warn('Invalid field: vendorOrganization');
        this.workorderEditModelValid = false;
      }
      if (errors && errors.length > 0) {
        console.warn('errors: ', errors);
        this.workorderEditModelValid = false;
      }
    },
  },
};
</script>
